import * as React from 'react';

import { Button, Card, Modal, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import ResetCodeComponent from '../shared/ResetCodeComponent'
import loginLogo from '../../assets/images/loginLogo.png'
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../shared/theme';
import { useState, useRef } from 'react';
import Alert from '@material-ui/lab/Alert';
import api from '../../store/api';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
interface SignUpVerifyEmailWidgetProps {
    inviteId: string | null,
    emailAddress: string | null,
    handleOnContinue: (code: string) => Promise<void>
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: 461,
        background: theme.palette.primary.main,
        borderRadius: 0,
    },
    errorMsg: {
        marginTop: 10,
        marginLeft: 40,
        marginRight: 40,
        color: '#EF2E22'
    },
    inputs: {
        marginTop: 10,
        marginLeft: 40,
        marginRight: 40,
    },
    button: {
        width: '100%',
        padding: 9,
        borderRadius: 5,
        background: 'white',
        color: theme.palette.primary.main,
        marginBottom: 40,
        fontSize: 'medium'
    },
    link: {
        color: 'whitesmoke',
        marginBottom: 30,
        marginLeft: 40,
        paddingLeft: 0,
        fontSize: 'small'
    },
    logoImg: {
        display: 'block',
        marginTop: 20,
        marginLeft: '30px',
        marginRight: 'auto',
        width: 374.67,
    },
    logoRoot: {
        height: 150
    },
    MailIcon: {
        marginLeft: 40,

    },
    mailOutlineIcon: {
        color: '#fff',
        fontSize: 44,
    },
    signUpHeading: {
        fontFamily: 'lato',
        fontSize: 28,
        color: '#fff',
        fontWeight: 'bold',
        lineHeight: 'normal',
    },
    heading: {
        marginLeft: 40,
    },
    form: {
        marginBottom: 40,
    },
    alertErrorRoot: {
        marginLeft: 40,
        marginRight: 40,
        marginBottom: 40
    },
    resetPassInputs: {
        backgroundColor: "#ffffff",
        margin: '0px 10px 0px 10px',
        borderRadius: '4px',
        width: '54px',
        height: '65px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '32px',
        color: '#212121',
        position: 'relative',
        cursor: 'text',
    }
}));


function SignUpVerifyEmailWidget(props: SignUpVerifyEmailWidgetProps) {
    const classes = useStyles();
    const codeInput = useRef<ResetCodeComponent>(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleContinue = async (): Promise<void> => {
        if (codeInput.current === null || codeInput.current?.state.value === undefined || codeInput.current?.state.value.length < 6) {
            setErrorMessage("Please enter code");
        }
        else {
            let req: { [index: string]: string } = {};
            req['InviteId'] = props.inviteId ?? '';
            req['Code'] = codeInput.current?.state.value;
            req['EmailAddress'] = props.emailAddress ?? '';
            setIsSubmitting(true);
            try {
                let res = await api.validateEmailChangeDuringSignUp('', req);
                if (res.data === true) {
                    await props.handleOnContinue(codeInput.current?.state.value);
                }
                else {
                    setErrorMessage("Invalid verification code");
                }
            }
            finally {
                setIsSubmitting(false);
            }
        }
    }
    return (
        <React.Fragment>

            <Card className={classes.root}>
                <div className={classes.logoRoot}>
                    <img src={loginLogo} className={classes.logoImg} alt="logo" />
                </div>

                <div className={classes.MailIcon}>
                    <MailOutlineIcon className={classes.mailOutlineIcon} />
                    <br />
                    <h2 className={classes.signUpHeading}>Enter the verification code we just emailed you</h2>
                </div>

                <div className={classes.form}>

                    <ResetCodeComponent ref={codeInput} className={classes.resetPassInputs} />
                </div>
                <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertErrorRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                    {errorMessage}
                </Alert>
                <div className={classes.inputs}>
                    <Button
                        onClick={handleContinue}
                        className={classes.button}
                        disabled={isSubmitting}
                        variant="contained">Continue</Button>
                </div>
            </Card>

        </React.Fragment >
    );
}

export default React.memo(SignUpVerifyEmailWidget) 
